import React from "react";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { BrandKnowledgePanel } from "./BrandKnowledgePanel";

/**
 * SYR-78 — admin inspector detail page: a back button + the reusable Brand
 * Knowledge panel (raw inputs, synthesised {BRAND_KNOWLEDGE}, documents).
 */
export const BrandKnowledgeInspectorDetailPage: React.FC = () => {
    const navigate = useNavigate();
    const { brandId } = useParams<{ brandId: string }>();

    return (
        <div style={{ padding: 24 }}>
            <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate("/admin/ai/knowledge_base/brands")}
                style={{ marginBottom: 16 }}
            >
                Back to brands
            </Button>
            <BrandKnowledgePanel brandId={Number(brandId)} />
        </div>
    );
};
